import { connect } from "react-redux";
import GeneralInformationSection from "../components/GeneralInformationSection";
import * as actionsTicket from "../../../_actions/ticket";

const mapStateToProps = ({ Ticket, Dimension, Misc }) => ({
    ticket: Ticket.data && Ticket.data.result,
    ticketData: Ticket.data,
    ticketUpdate: Ticket.update && Ticket.update.result,
    ticketUpdating: Ticket.updating.loading,
    ticketUpdatingError: Ticket.updating.err,

    //Misc
    language: Misc.Settings.language
});

const mapDispatchToProps = dispatch => ({
    setTicketUpdate: ticketData => {
        dispatch(actionsTicket.setTicketUpdate(ticketData));
    }
});

export default connect(mapStateToProps, mapDispatchToProps)(GeneralInformationSection);
